import { ReactNode } from 'react';
import { FormControl, FormGroup, FormLabel, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  theme => ({
    root: {
      marginTop: theme.spacing(2),
    },
    label: {
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: theme.typography.body1.fontSize,
      marginBottom: theme.spacing(1),
    },
  }),
  { name: 'Filter' },
);

export const Filter = ({ label, children }: { label: string; children: ReactNode }) => {
  const classes = useStyles();

  return (
    <FormControl component="fieldset" className={classes.root}>
      <FormLabel component="legend" className={classes.label}>
        {label}
      </FormLabel>
      <FormGroup>{children}</FormGroup>
    </FormControl>
  );
};
